import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

// Async thunk for fetching top sales items based on filter
export const getTopSalesItems = createAsyncThunk(
  "topSalesItems/getTopSalesItems",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/reports/top_sales_items?filter=${filter}`);
      return response.data;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);

const topSalesItemsSlice = createSlice({
  name: "topSalesItems",
  initialState: {
    loading: false,
    error: null,
    topSalesItems: [],
  },
  reducers: {
    resetTopSalesItemsState: (state) => {
      state.loading = false;
      state.error = null;
      state.topSalesItems = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTopSalesItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopSalesItems.fulfilled, (state, action) => {
        state.loading = false;
        state.topSalesItems = action.payload;
      })
      .addCase(getTopSalesItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTopSalesItemsState } = topSalesItemsSlice.actions;

export default topSalesItemsSlice.reducer;
